export default __webpack_public_path__ + "static/media/11_cortado.058d95ee.webp";